import { FormattedMessage } from 'react-intl';
import { TransportAssignmentStatus } from '../transportAssignment/transportAssignment.types';
import classNames from 'classnames';
import { ServiceOrderStatus } from '../serviceOrders/serviceOrders/serviceOrder.types';
import { ActivationStatus } from '../activation/activation.types';
import { ServiceOptionStatus } from '../serviceOrders/serviceOptions/serviceOption.types';

export type StatusLabelProps = {
    status: TransportAssignmentStatus | ServiceOrderStatus | ServiceOptionStatus | ActivationStatus;
    className?: string;
};

const statusLabelColoring = (
    status: TransportAssignmentStatus | ServiceOrderStatus | ServiceOptionStatus | ActivationStatus,
): string => {
    const defaultStatusLabelStyle = 'label label-condensed';
    switch (status) {
        case TransportAssignmentStatus.CANCELLATION:
        case ServiceOrderStatus.CANCELLED:
        case ServiceOptionStatus.CANCELLED:
            return `${defaultStatusLabelStyle} label-danger`;
        case TransportAssignmentStatus.INCOMPLETE_CONFIRMED:
        case TransportAssignmentStatus.COMPLETE_CONFIRMED:
            return `${defaultStatusLabelStyle} label-primary`;
        case TransportAssignmentStatus.UNCONFIRMED:
        case ServiceOrderStatus.OPEN:
        case ServiceOptionStatus.OPEN:
            return `${defaultStatusLabelStyle} label-muted label-filled`;
        case ActivationStatus.PENDING:
        case TransportAssignmentStatus.LOADED:
            return `${defaultStatusLabelStyle} label-primary label-filled`;
        case TransportAssignmentStatus.UNLOADED:
        case ActivationStatus.ACTIVE:
        case ServiceOrderStatus.COMPLETED:
        case ServiceOptionStatus.CLOSED:
            return `${defaultStatusLabelStyle} label-success label-filled`;
    }
};

export const statusMessageId = (
    status: TransportAssignmentStatus | ServiceOrderStatus | ServiceOptionStatus | ActivationStatus,
): string => {
    switch (status) {
        case TransportAssignmentStatus.CANCELLATION:
        case ServiceOrderStatus.CANCELLED:
        case ServiceOptionStatus.CANCELLED:
            return 'outboundOrderBook.common.status.cancelled';
        case TransportAssignmentStatus.INCOMPLETE_CONFIRMED:
        case TransportAssignmentStatus.COMPLETE_CONFIRMED:
            return 'outboundOrderBook.common.status.confirmed';
        case TransportAssignmentStatus.UNCONFIRMED:
            return 'outboundOrderBook.common.status.unconfirmed';
        case TransportAssignmentStatus.LOADED:
            return 'outboundOrderBook.common.status.loaded';
        case TransportAssignmentStatus.UNLOADED:
            return 'outboundOrderBook.common.status.unloaded';
        case ServiceOrderStatus.OPEN:
        case ServiceOptionStatus.OPEN:
            return 'outboundPortal.serviceOrders.status.open';
        case ServiceOrderStatus.COMPLETED:
            return 'outboundPortal.serviceOrders.status.completed';
        case ServiceOptionStatus.CLOSED:
            return 'outboundOrderBook.serviceOptions.status.closed';
        case ActivationStatus.PENDING:
            return 'outboundOrderBook.serviceProviders.pending';
        case ActivationStatus.ACTIVE:
            return 'outboundOrderBook.serviceProviders.active';
    }
};

export const StatusLabel = ({ status, className }: StatusLabelProps) => {
    return (
        <span className={classNames(className, statusLabelColoring(status))}>
            <FormattedMessage id={statusMessageId(status)} />
        </span>
    );
};
